const fetchAuthenticatedContent = require("./fetchAuthenticatedContent");

module.exports = async function fetchUserData(dispatch) {
	let d = false;
	const root_data = await fetchAuthenticatedContent({ endpoint: "", dispatch });
	if (root_data && !root_data.error) {
		if (root_data?.meta?.links?.me?.meta?.id) {
			const user_data = await fetchAuthenticatedContent({
				endpoint: "user/user/" + root_data.meta.links.me.meta.id,
				dispatch,
			});
			if (user_data && !user_data.error) {
				const roles =
					user_data.data?.relationships?.roles?.data &&
					Array.isArray(user_data.data.relationships.roles.data) &&
					user_data.data.relationships.roles.data.length > 0
						? user_data.data.relationships.roles.data.map((r) => r.id)
						: [];
				d = { ...user_data.data, roles };
			}
		}
	}
	return d;
};
